<template>
    <div class="pb-12" v-if="validType">

        <div class="row">
            <div class="col-lg-6">
                <h3>Data Quota</h3>
            </div>
            <div class="col-lg-6">
                <p class="text-lg-right sau-font sm pt-2" v-if="lastUpdated">Last Updated: {{ lastUpdated |  moment('DD/MM/YYYY H:mm:ss')}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6" v-if="monthSelected.value">
                <h5>Usage Summary for {{ monthSelected.value | moment('MMMM YYYY') }}</h5>
            </div>
            <div class="col-lg-6" v-if="lastUpdated">
                <div class="text-right" v-on-clickaway="turnOffMenu">
                    <div class="sau-menu text-center">
                        <button class="dropbtn sau-font sm px-0">View History <i class="fa fa-chevron-down" aria-hidden="true"></i></button>
                        <div class="sau-menu-content dd sau-menu-content-overflow">
                            <a href="#" @click.prevent="updateUsageGraph({ 'value': item.value, 'text': item.text })" v-for="(item, index) in menu" :key="index">{{ item.text }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="gotData">
            <div class="col" v-if="quota">
                <div class="sau-bx bx-pad">
                    <p v-if="transit">Pooled data from <a :href="transit.link">{{transit.sau_order_id}} - {{transit.name}}</a></p>
                    <p>{{ calculateRemaining }}</p>
                    <canvas id="bandwidth" class="horizontal-double-bar-graph" style="height:100px; width:100%;" :class="style" :data-points="JSON.stringify(quota)"></canvas>
                    <p class="sau-font sm pt-2"><span class="sau-font-bold">Quota:</span> {{ quota.assigned }}, <span class="sau-font-bold">Inbound:</span> {{ quota.in }} ({{quota.percentIn}}%), <span class="sau-font-bold">Outbound:</span> {{ quota.out }} ({{quota.percentOut}}%), <span class="sau-font-bold">Total Used:</span> {{ quota.total }} ({{quota.usage}}%)</p>
                </div>
                <p v-if="link" class="sau-font sm text-center">
                    <i class="fas fa-link sau-font-color blue"></i>
                    <a :href="networkLink">View Network Usage</a>
                </p>
            </div>
            <div class="col" v-else>

                <sau-apiro-response type="message" support="true">
                    <template slot="message">No data quota graphs available.</template>
                    <template slot="details">
                        <p>We can't retrieve your bandwidth data at the moment. However support can quickly attend to this.</p>
                    </template>
                </sau-apiro-response>

            </div>
        </div>
        <div class="row" v-else>
            <div class="col">
                <sau-loading>
                    <template slot="message">Fetching Data Quota</template>
                </sau-loading>
            </div>
        </div>

    </div>
</template>

<script>
import { BasicSelect } from 'vue-search-select';
import { mixin as clickaway } from 'vue-clickaway';
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    components: {BasicSelect},
    props:['service', 'link'],
    mixins: [clickaway, jsFunctions],
    data() {
        return {
            startDate: '',
            endDate: '',
            remaining: '',
            history: '',
            lastUpdated: '',
            monthSelected: '',
            quota: '',
            activeMenu: false,
            transit: '',
            type: ''
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getBandwidthQuota().then(response => {
                if(response.data.status == 'success' && !response.data.message) {
                    this.menu = response.data.menu;
                    this.startDate = response.data.startDate;
                    this.endDate = response.data.endDate;
                    this.remaining = response.data.daysRemaining;
                    this.history = response.data.history;
                    this.lastUpdated = response.data.lastUpdated;
                    if(response.data.device) {
                        this.transit = response.data.device;
                    }
                    this.type = response.data.type;
                    /** Default to the current month */
                    this.monthSelected = this.menu[0];
                    this.style = '';
                    this.calculateUsage();
                }
            })
        },
        calculateUsage() {
            this.quota = this.history[this.monthSelected.value];
            this.$nextTick(() => {
                this.checkGraphs();
            });
        },
        updateUsageGraph(month) {
            this.monthSelected = month;
            this.calculateUsage();
        },
        turnOffMenu() {
            this.activeMenu = false;
        },
        toggleMenu() {
            this.activeMenu = !this.activeMenu;
        },
        actionSupport(){
            this.$store.commit('setServiceSupportAction', true);
        }
    },
    computed: {
        calculateRemaining() {
            // display this.remaining if current month
            return this.monthSelected.text == this.endDate ? this.remaining : 'Month Completed';
        },
        validType() {
            // Theoretically there are only two quota types, so this could just return true..? But lets future proof it because it's SAU.. :D
            return this.type.toLowerCase() === 'quota' || this.type.toLowerCase() === 'cdr' ;
        }
    }
}
</script>
<style>
.sau-menu-content-overflow {
    overflow-y: scroll;
    max-height: 25vh;
}
</style>
